import { useRef, useState } from "react";
import { IMaskInput } from "react-imask";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";

export default function SSNInput({
  name,
  describedby,
  register,
  setValue,
  required = true,
  length = "lastFour",
  isDisabled = false,
}) {
  // DEV NOTE:
  // In order to show the eye toggle, please make sure input wrapping div has class relative
  const { t } = useTranslation();
  const [hideFieldValue, setHideFieldValue] = useState(true);
  const ref = useRef(null);
  const inputRef = useRef(null);

  return (
    <>
      <IMaskInput
        ref={ref}
        inputRef={inputRef} // access to nested input
        type={hideFieldValue ? "password" : "text"}
        mask={length === "full" ? "000-00-0000" : "0000"}
        placeholder={length === "full" ? "###-##-####" : "####"}
        unmask={true}
        lazy={true}
        disabled={isDisabled}
        placeholderChar="#"
        // DO NOT USE onChange TO HANDLE CHANGES!
        // USE onAccept INSTEAD
        onAccept={
          // depending on prop above first argument is
          // `value` if `unmask=false`,
          // `unmaskedValue` if `unmask=true`,
          // `typedValue` if `unmask='typed'`
          (value, mask) => {
            setValue(name, value);
          }
        }
        {...register(name, {
          required: required ? t("SSNInput-input-required") : null,
          validate: {
            fourDigit: (value) => {
              if (!required) return null;

              switch (length) {
                case "full":
                  return value?.length === 9
                    ? null
                    : t("SSNInput-input-required");
                default:
                  return value?.length === 4
                    ? null
                    : t("SSNInput-input-required");
              }
            },
          },
        })}
        aria-describedby={describedby}
      />
      <div className="absolute top-8 right-4">
        {hideFieldValue ? (
          <AiOutlineEye
            onClick={() => setHideFieldValue((current) => !current)}
          ></AiOutlineEye>
        ) : (
          <AiOutlineEyeInvisible
            onClick={() => setHideFieldValue((current) => !current)}
          ></AiOutlineEyeInvisible>
        )}
      </div>
    </>
  );
}
